import { defaultAxios, IParams } from './base';

export interface IFetchLoanBanner extends IParams {
  mediaCd: string;
  placementType: string;
}

export const fetchLoanBanner = async (params: IFetchLoanBanner) => {
  return await defaultAxios().post(`/loan/banner`, params);
};
